var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContainer",staticClass:"scroll-container",on:{"mousewheel":_vm.handleScroll}},[_c('div',{ref:"scrollWrapper",staticClass:"scroll-wrapper",style:({left: _vm.left + 'px'})},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }